import { AlertTitle, Typography } from "@mui/material"
import { ReactElement } from "react"

import AppAlert from "../../components/dataDisplay/alerts/appAlert"

interface DeviceSupersededDisplayProps {
    supersededDeviceRef: string
    latestDeviceRef: string
}

export const DeviceSupersededDisplay = ({
    supersededDeviceRef,
    latestDeviceRef,
}: DeviceSupersededDisplayProps): ReactElement => (
    <AppAlert severity="warning" icon={false}>
        <AlertTitle>
            <Typography variant="h5" fontWeight={500}>
                {`${supersededDeviceRef} has been superseded by ${latestDeviceRef} (this device!)`}
            </Typography>
        </AlertTitle>
        You clicked on a hyperlink that was a bit out of date. We have
        redirected you to the latest amendment for this device, which means you
        are viewing the most up to date and accurate information!
    </AppAlert>
)
